import { middlewareController } from '../middlewareController'

const BASE_URL = process.env.REACT_APP_INNOS_HR_BACKEND

export const hrApi = middlewareController.create.axiosInstance({
  baseURL: BASE_URL
})

export * from './hrApi.types'
export * from './requests'
